export default "__VITE_ASSET__6a600c74__"